import axios from "axios";
import { getRefreshToken, getUserName, getToken } from "../../cookie/authCookie";
import { AuthAPI } from "../AuthAPI";
import { Cookies } from 'react-cookie';
import { dispatch } from "../../redux/store/store";
import { resetUser } from "../../redux/reducer/userReducer";

const cookies = new Cookies();



const DEV_URL = "http://court-management-api-dev.eba-qzpqzawe.us-east-1.elasticbeanstalk.com/court-management/api/v1";
const O_PHONE_BASE_URL = "http://192.168.198.170:8080/court-management/api/v1"  //
const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_APP_BASE_URL}`

});


//// TODO 
axiosInstance.interceptors.response.use(

  (res) => {
    return res
  },

  (error) => {

    console.error("error in instance",error);
    if(error?.response?.data?.customErrorCode === "4001") {
      cookies.remove('access_token')
      cookies.remove('refresh_token')
      cookies.remove('user_info')
      dispatch(resetUser());
    }
    return Promise.reject(error)
  }
)

export default axiosInstance